const InputField = ({ label, value, onChange, name, disabled = false, helper }) => (
    <div className="flex flex-col gap-2 w-full">
        <label className="text-sm font-medium text-slate-600 mr-1">{label}</label>
        <input
            type="text"
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            className={`
                h-11 px-4 rounded-xl border transition-all outline-none text-sm
                ${disabled 
                    ? "bg-slate-50 text-slate-400 border-slate-100 cursor-not-allowed" 
                    : "bg-white border-slate-200 focus:border-[#8b6bd9] focus:ring-4 focus:ring-purple-50 text-slate-700"
                }
            `}
        />
        {helper && <p className="text-[10px] text-slate-400 mr-1">{helper}</p>}
    </div>
);

export default InputField